import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useState } from "react";
import postDataRoad from "../../../services/postDataRoad";

export default function CreateContact({
  customer,
  isVisible,
  setVisible,
  refetch,
}: any) {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState<boolean>(false);
  const onSubmit = async () => {
    setLoading(true);
    const values = await form.validateFields();
    const uri = "customers/contact";
    const data = { customer: customer?._id, ...values };
    const response = await postDataRoad(data, uri);
    if (response.success) {
      message.success("Created Successfully");
    } else {
      message.error(response?.message);
      setLoading(false);
      return;
    }

    refetch();
    setLoading(false);
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      visible={isVisible}
      title="New Contact"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createCustomer"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          danger
          loading={isLoading}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createCustomer"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="flex flex-row, justify-between"></div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter name",
                },
              ]}
            >
              <Input placeholder="Full Name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile"
              rules={[
                {
                  required: true,
                  message: "Please enter mobile",
                },
              ]}
            >
              <Input placeholder="Mobile Number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="email"
              rules={[
                {
                  required: false,
                  message: "Please enter email",
                },
              ]}
            >
              <Input placeholder="Email (Optional)" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address"
              rules={[
                {
                  required: false,
                  message: "Please enter address",
                },
              ]}
            >
              <Input placeholder="Address (Optional)" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
